export default __webpack_public_path__ + "assets/images/98613ddfd9020babbc02aae325f1df5a.png";